interface Option {
  value: string;
  label?: React.ReactNode;
  disabled?: boolean;
  children?: Option[];
  // 标记是否为叶子节点，设置了 `loadData` 时有效
  // 设为 `false` 时会强制标记为父节点，即使当前节点没有 children，也会显示展开图标
  isLeaf?: boolean;
}

const generateHouseHoldNumberCascader = (data: string[]): Option[] => {
  const result: Option[] = [];
  const spreadData = data
    .sort((a, b) => a.localeCompare(b))
    .map((item) => item.split('-')); // ["1-2-3",...] => [["1", "2", "3"],...]
  spreadData.forEach((numbers) => {
    let currentOptions = result; // 最外層的Option[]
    numbers.forEach((number, index, arr) => {
      // 例如numbers = ["1", "2", "3"]，那麼就先在最外層的Option[]裡面找有沒有value為"1"的Option作為target，如果沒有就新增一個
      // 然後把這個Option指定給target
      let target = currentOptions.find((option) => option.value === number);
      if (!target) {
        const newOption: Option = {
          value: number,
          label: number,
        };
        currentOptions.push(newOption);
        target = newOption;
      }
      // 如果當下的number例如"2"不是最後一個
      if (index !== arr.length - 1) {
        // 先確認target有沒有children屬性，沒有就新增一個
        target.children = target.children || [];
        // 把target的children指定給currentOptions，這樣下一輪的currentOptions就是當下target的children
        currentOptions = target.children;
      }
    });
  });
  return result;
};

export { generateHouseHoldNumberCascader, Option };
